export const getBirthDays = () => {
  const days = [];
  for (let i = 0; i < 31; i++) {
    const day = `0${i + 1}`.slice(-2).toString();
    days.push({
      label: day,
      value: day
    });
  }
  return days;
};
export const getBirthMonths = (t = v => v) => {
  const months = [];
  const monthsName = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  for (let i = 0; i < 12; i++) {
    months.push({
      label: t(monthsName[i]),
      value: i + 1
    });
  }
  return months;
};
export const getBirthYears = (minimumAge = 17) => {
  const years = [];
  for (let i = 1; i < 101; i++) {
    const year = new Date().getFullYear() - minimumAge - (100 - i).toString();
    years.push({
      label: year.toString(),
      value: year.toString()
    });
  }
  return years;
};
export const getMonthLabel = (month, t) => {
  var _months$find$label, _months$find;
  // eslint-disable-next-line no-undefined
  if (month === null || month === undefined) {
    return null;
  }
  let monthValue = month;
  if (typeof month === "string") {
    monthValue = Number(month);
  }
  const months = getBirthMonths(t);
  return (_months$find$label = (_months$find = months.find(m => m.value === monthValue)) === null || _months$find === void 0 ? void 0 : _months$find.label) !== null && _months$find$label !== void 0 ? _months$find$label : null;
};